import { Box, Typography } from "@mui/material";
import TkHelpIcon from "../../components/atoms/TkHelpIcon";
import "./_style.scss";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const infoManual = (
  <div>
    職員の一覧を表示しています。
    <br />
    すでに退職（「共済制度上の退職」
    <TkHelpIcon
      helpMessage={
        <>
          「共済制度上の退職」とは主に次のようなケースが該当し、引き続き勤務されるようなケースにおいても「退職」の扱いとなります。
          <br />
          ①加入要件を満たさない雇用条件に変更する雇用契約を締結した場合
          <br />
          ②本制度の契約対象外の施設等に配置換え（異動）した場合
          <br />
          ③雇用契約期間満了に伴う「雇用契約更新」を行う場合
          <br />
          詳しくは、
          <a
            href={`${
              process.env.PUBLIC_URL ?? ""
            }/assets/pdf/≪別紙≫本制度の「退職」について.pdf`}
            target="_blank"
            rel="noreferrer"
          >
            こちら
          </a>
          をご確認ください。
        </>
      }
    />
    を含む）をしている職員がいる場合は、「退職情報登録」ボタンを押して退職情報を登録してください。
  </div>
);

const headTitleList = [
  {
    headTitle: (
      <Box className="tkHeadTitle">
        <Typography>{"施設名称"}</Typography>
        <TkHelpIcon helpMessage="登録されている施設・事業の名称です。" />
      </Box>
    ),
  },
  {
    headTitle: (
      <Box className="tkHeadTitle">
        <Typography>{"氏名"}</Typography>
        <TkHelpIcon helpMessage="登録されている被共済職員の氏名です。外字や「髙（はしごだか）」、「﨑（たつさき）」等の常用漢字でない文字は、正しく表示されていない場合があります。" />
      </Box>
    ),
  },
  {
    headTitle: (
      <Box className="tkHeadTitle">
        <Typography>{"生年月日"}</Typography>
        <TkHelpIcon helpMessage="登録されている被共済職員の生年月日です。" />
      </Box>
    ),
  },
  {
    headTitle: (
      <Box className="tkHeadTitle">
        <Typography>{"退職予定日"}</Typography>
        <TkHelpIcon helpMessage="退職が予定されている職員の退職予定日です。" />
      </Box>
    ),
  },
  {
    headTitle: (
      <Box className="tkHeadTitle">
        <Typography>{"退職情報登録"}</Typography>
        <TkHelpIcon helpMessage="退職する（した）職員がいる場合は、「退職情報登録」ボタンを押して退職の手続きを行ってください。" />
      </Box>
    ),
    dontNeedSort: true,
  },
];

const searchFormList: any = [
  {
    label: "施設名",
    keyword: "facilityName",
    type: "label",
    inputProps: {
      maxLength: 85,
    },
  },
  {
    label: "職員名",
    keyword: "staffNameKanji",
    type: "label",
    inputProps: {
      maxLength: 85,
    },
  },
];

const searchFormSchema = {
  facilityName: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  staffNameKanji: {
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { infoManual, headTitleList, searchFormList, searchFormSchema };
